import auth from "@/services/ExerciseInitAuth"

const upload = (data, noIndicator) =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/media-files/`, data, {}, noIndicator);

export default {
  upload
}